class RfidParser {
    static HIDSeussHexParser = (hex: string): { facility: number, internal_card: number } => {
        if (parseInt(hex, 16) == 0 || isNaN(parseInt(hex, 16))) { throw new Error("Invalid hex code!") }

        const binary = parseInt(hex, 16).toString(2)
        if (binary.length > 26) { throw new Error("Invalid hex code, more than 26 bit!") }

        // from right most bit
        // 1st bit = parity
        // 2-16th bit = internal card number
        // last 8 bit = facility number
        let internal_bit = binary.split('').reverse().slice(1, 17).reverse().join("")
        let facility_bit = binary.split('').reverse().slice(17).reverse().join("")

        return { facility: parseInt(facility_bit, 2), internal_card: parseInt(internal_bit, 2) }
    }
}

export default RfidParser